function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareLocaleKeys from '../../../locales/keys';
import { GiftOrderPreviewAsMutableSelector, GiftOrderRedemptionCodeSelector, GiftOrderRequiresPaymentInstrumentSelector, GiftOrderSelectedShippingAddressSelector, GiftOrderShipToNameSelector, GiftOrderSubmitSelector, GiftOrderSubscriptionQuotesAsMutableSelector, IsFetchingPreviewGiftOrderSelector, IsSubmittingGiftOrderRedemptionSelector, SelectedShippingMethodSelector, ShippingAddressesAvailableForGiftOrder, SubscriptionRenewalChargeAndCurrencySelector } from '../../../reducers/selectors/redeem.gift.order.selectors';
import { getDefaultPaymentMethodFromPaymentInstruments } from '../../../reducers/helpers/ewallet.reducer.helper';
import { IsRetrievingEwalletDataSelector, PaymentInstrumentsWithTypeNamesViewModel } from '../../../reducers/selectors/customer.ewallet.selectors';
import { CurrentCustomerIdSelector, CurrentCustomerStateSelector } from './../../../reducers/selectors/customer.selectors';
import { AddressesErrorSelector, IsFetchingAddressesSelector } from './../../../reducers/selectors/customer.addresses.selectors';
import { retrieveAvailablePaymentInstrumentTypes } from './../../../reducers/actions/customer.ewallet.actions';
import { retrieveCustomerAddresses } from './../../../reducers/actions/customer.addresses.actions';
import { fetchWallet } from '../../../reducers/actions/edit.offer.wizard.actions';
import { fetchGiftOrderPreview, resetRedeemGiftOrder, setSelectedShippingMethod, submitRedeemGiftOrder, updateGiftOrderRedemptionCode, updateGiftOrderSelectedShippingAddress, updateGiftOrderShipToName, updatePreviewWithSubscriptionsQuote } from '../../../reducers/actions/redeem.gift.order.actions';
import { i18n, MetadataActions, MetadataConstants, MetadataSelectors } from 'invision-core';
import { stateGo } from 'redux-ui-router';
import { retrieveCustomerHouseholds } from '../../../reducers/actions/customer.household.actions';
import { any, pathOr } from 'ramda';
import { retrieveCustomer } from '../../../reducers/actions/customer.actions';
import { CUSTOMER_STATE } from '../../shared/constants/customer.constants';
var PRODUCT_IMAGE_WIDTH = 200;
var RedeemGiftOrderController = /*#__PURE__*/function () {
  function RedeemGiftOrderController($ngRedux, $timeout, $filter, uiNotificationService) {
    _classCallCheck(this, RedeemGiftOrderController);
    this.$ngRedux = $ngRedux;
    this.$timeout = $timeout;
    this.$filter = $filter;
    this.uiNotificationService = uiNotificationService;
    this.addressFormFieldLocaleKeyMapping = {
      shipToName: CustomerCareLocaleKeys.ADDRESSES.SHIP_TO_NAME
    };
    this.onAddressSwitcherChangeCallback = this.onAddressSwitcherChangeCallback.bind(this);
    this.onAddressSwitcherCreateOrEditCallback = this.onAddressSwitcherCreateOrEditCallback.bind(this);
    this.onChangePaymentInstrumentCallback = this.onChangePaymentInstrumentCallback.bind(this);
    this.getAdditionalInformationHeading = this.getAdditionalInformationHeading.bind(this);
    this.selectedShippingMethod = null;
  }
  return _createClass(RedeemGiftOrderController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      this.localeKeys = CustomerCareLocaleKeys;
      this.stateOrName = 'index.customercare.customer.redeemGiftOrder';
      this.product_image_width = PRODUCT_IMAGE_WIDTH;
      this.currentPaymentInstrument;
      this.showPaymentInformation = false;
      this.showAddressInformation = false;
      this.paymentMethodErrorMessages = [];
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addressesServiceError: AddressesErrorSelector(store),
          availableAddresses: ShippingAddressesAvailableForGiftOrder(store),
          currentCustomerState: CurrentCustomerStateSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          giftOrderPreview: GiftOrderPreviewAsMutableSelector(store),
          giftOrderRequiresPaymentInstrument: GiftOrderRequiresPaymentInstrumentSelector(store),
          giftOrderSubmit: GiftOrderSubmitSelector(store),
          isFetchingAddresses: IsFetchingAddressesSelector(store),
          isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
          isFetchingPreviewGiftOrder: IsFetchingPreviewGiftOrderSelector(store),
          isSubmittingGiftOrderRedemption: IsSubmittingGiftOrderRedemptionSelector(store),
          redemptionCode: GiftOrderRedemptionCodeSelector(store),
          selectablePaymentInstruments: PaymentInstrumentsWithTypeNamesViewModel(store),
          selectedShippingAddress: GiftOrderSelectedShippingAddressSelector(store),
          selectedShippingMethod: SelectedShippingMethodSelector(store),
          shippingMethods: MetadataSelectors.shippingMethods.ShippingMethodsSelector(store),
          shippingMethodsIsLoading: MetadataSelectors.shippingMethods.ShippingMethodsMetadataIsLoadingSelector(store),
          shipToName: GiftOrderShipToNameSelector(store),
          structureTypesLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(MetadataConstants.codes.StructureType, store),
          structureTypes: MetadataSelectors.codes.MetadataCodeTypeSelector(MetadataConstants.codes.StructureType, store),
          subscriptionQuotes: GiftOrderSubscriptionQuotesAsMutableSelector(store),
          subscriptionRenewalChargeAndCurreny: SubscriptionRenewalChargeAndCurrencySelector(store)
        };
      };
      var controllerActions = {
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        fetchGiftOrderPreview: fetchGiftOrderPreview,
        fetchWallet: fetchWallet,
        getShippingMethodsByCountryCode: MetadataActions.shippingMethods.getShippingMethodsByCountryCode,
        resetRedeemGiftOrder: resetRedeemGiftOrder,
        retrieveCustomer: retrieveCustomer,
        retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
        retrieveCustomerAddresses: retrieveCustomerAddresses,
        retrieveCustomerHouseholds: retrieveCustomerHouseholds,
        setSelectedShippingMethod: setSelectedShippingMethod,
        stateGo: stateGo,
        submitRedeemGiftOrder: submitRedeemGiftOrder,
        updateGiftOrderRedemptionCode: updateGiftOrderRedemptionCode,
        updateGiftOrderSelectedShippingAddress: updateGiftOrderSelectedShippingAddress,
        updateGiftOrderShipToName: updateGiftOrderShipToName,
        updatePreviewWithSubscriptionsQuote: updatePreviewWithSubscriptionsQuote
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.redemptionCode = this.state.redemptionCode;
      if (!this.state.structureTypesLoaded) {
        this.actions.fetchCodeType(MetadataConstants.codes.StructureType);
      }
      this.submitRedeemGiftOrderSuccessConfig = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.submitRedeemGiftOrderSuccessPopup = evt.api;
        }
      };
      this.submitRedeemGiftOrderErrorConfig = {
        onRegisterApi: function onRegisterApi(evt) {
          _this.submitRedeemGiftOrderErrorPopup = evt.api;
        }
      };
      this.submitRedeemGiftOrderSuccessRedirect = function () {
        _this.submitRedeemGiftOrderSuccessPopup.close();
        if (_this.state.currentCustomerState === CUSTOMER_STATE.PROSPECT) {
          _this.actions.retrieveCustomer(_this.state.currentCustomerId);
        }
        _this.actions.stateGo('index.customercare.customer.dashboard', {
          customerId: _this.state.currentCustomerId
        });
      };
      this.closeSubmitRedeemGiftOrderErrorPopup = function () {
        _this.submitRedeemGiftOrderErrorPopup.close();
      };

      // Preview Renewal Statements Popup Dialog bits
      this._previewRenewalStatementsPopupApi = null;
      this.showPreviewRenewalStatementsDialog = false;
      this.previewRenewalStatementsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this._previewRenewalStatementsPopupApi = event.api;
        }
      };
      this.handleRedemptionCodeInputKeydown = function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          _this.handleGiftOrderPreviewClick();
        }
      };
      this.loadHouseholdData();
    }
  }, {
    key: "getAdditionalInformationHeading",
    value: function getAdditionalInformationHeading() {
      var headingProperty = '';
      if (this.showAddressInformation && this.showPaymentInformation) {
        headingProperty = this.localeKeys.REDEEM_GIFT_ORDER.PAYMENT_AND_SHIPPING_TITLE;
      } else if (this.showAddressInformation) {
        headingProperty = this.localeKeys.SHIPPING_INFORMATION;
      } else if (this.showPaymentInformation) {
        headingProperty = this.localeKeys.PAYMENT_INFORMATION;
      }
      return i18n.translate(headingProperty);
    }
  }, {
    key: "loadHouseholdData",
    value: function loadHouseholdData() {
      var _this2 = this;
      if (!this.state.currentHousehold) {
        this.actions.retrieveCustomerHouseholds(this.state.currentCustomerId, false).finally(function () {
          _this2.initializedHouseholdData = true;
        });
      } else {
        this.initializedHouseholdData = true;
      }
    }
  }, {
    key: "isLoading",
    value: function isLoading() {
      return this.state.isFetchingPreviewGiftOrder || this.state.isSubmittingGiftOrderRedemption || this.state.isFetchingEwalletData || !this.initializedHouseholdData || this.state.shippingMethodsIsLoading;
    }
  }, {
    key: "_handleAddressesForGiftOrderPreviewOfShippableGift",
    value: function _handleAddressesForGiftOrderPreviewOfShippableGift() {
      var _this3 = this;
      this._updateAddressOnGift(this.state.giftOrderPreview.shippingAddress);
      this.actions.retrieveCustomerAddresses(this.state.currentCustomerId).catch(function () {
        if (_this3.state.addressesServiceError) {
          _this3.uiNotificationService.error(_this3.state.addressesServiceError.translatedMessage);
        }
      });
    }
  }, {
    key: "_handlePaymentMethodsForGiftOrderPreviewOfSubscriptionGift",
    value: function _handlePaymentMethodsForGiftOrderPreviewOfSubscriptionGift() {
      var _this4 = this;
      this.actions.fetchWallet(this.state.currentCustomerId).then(function () {
        _this4.currentPaymentInstrument = getDefaultPaymentMethodFromPaymentInstruments(_this4.state.selectablePaymentInstruments);
        if (_this4.currentPaymentInstrument) {
          _this4.actions.updatePreviewWithSubscriptionsQuote(_this4.redemptionCode, _this4.currentPaymentInstrument.Id, _this4.state.currentCustomerId).catch(function (error) {
            _this4.uiNotificationService.error(error.translatedMessage);
          });
        }
      }).catch(function () {
        if (_this4.state.retrieveEwalletError) {
          _this4.uiNotificationService.error(_this4.state.retrieveEwalletError.message);
        }
      });
      this.actions.retrieveCustomerHouseholds(this.state.currentCustomerId);
    }
  }, {
    key: "handleGiftOrderPreviewClick",
    value: function handleGiftOrderPreviewClick() {
      var _this5 = this;
      this.showAddressInformation = false;
      this.showPaymentInformation = false;
      this.actions.retrieveAvailablePaymentInstrumentTypes();
      this.actions.fetchGiftOrderPreview(this.redemptionCode).then(function () {
        if (_this5.state.giftOrderRequiresPaymentInstrument) {
          _this5.showPaymentInformation = true;
          _this5._handlePaymentMethodsForGiftOrderPreviewOfSubscriptionGift();
        }
        if (_this5.state.giftOrderPreview.shippingAddress) {
          _this5.showAddressInformation = true;
          _this5._handleAddressesForGiftOrderPreviewOfShippableGift();
          _this5._updateShippingMethodOnChange();
        }
      });
      this.actions.updateGiftOrderRedemptionCode(this.redemptionCode);
    }
  }, {
    key: "onChangePaymentInstrumentCallback",
    value: function onChangePaymentInstrumentCallback(paymentInstrument) {
      var _this6 = this;
      //Set the current active payment instrument
      this.currentPaymentInstrument = paymentInstrument;
      this.actions.updatePreviewWithSubscriptionsQuote(this.redemptionCode, this.currentPaymentInstrument.Id, this.state.currentCustomerId).catch(function (error) {
        _this6.uiNotificationService.error(error.translatedMessage);
      });
      if (paymentInstrument) {
        this.paymentMethodErrorMessages = [];
      }
    }
  }, {
    key: "handlePreviewRenewalStatements",
    value: function handlePreviewRenewalStatements() {
      this.showPreviewRenewalStatementsDialog = true;
      this.$timeout(this._previewRenewalStatementsPopupApi.open);
    }
  }, {
    key: "handleClosePreviewRenewalStatementsDialog",
    value: function handleClosePreviewRenewalStatementsDialog() {
      this.showPreviewRenewalStatementsDialog = false;
      this._previewRenewalStatementsPopupApi.close();
    }
  }, {
    key: "handleSubmitGiftOrder",
    value: function handleSubmitGiftOrder() {
      var _this7 = this;
      var hasRequiredPaymentInstrument = !this.showPaymentInformation || this.showPaymentInformation && pathOr(false, ['currentPaymentInstrument', 'Id'], this);
      if (!hasRequiredPaymentInstrument) {
        this.paymentMethodErrorMessages = [i18n.translate(CustomerCareLocaleKeys.REDEEM_GIFT_ORDER.PAYMENT_REQUIRED_ERROR)];
      }
      if (this.redemptionForm && this.redemptionForm.$valid && hasRequiredPaymentInstrument) {
        this.actions.updateGiftOrderRedemptionCode(this.redemptionCode);
        this.actions.submitRedeemGiftOrder({
          redemptionCode: this.redemptionCode,
          shippingAddress: this.state.giftOrderPreview.shippingAddress ? this.state.selectedShippingAddress : null,
          shippingMethodId: this.state.giftOrderPreview.shippingMethod ? pathOr(null, ['state', 'selectedShippingMethod', 'Id'], this) : null,
          shipToName: this.state.giftOrderPreview.shippingAddress ? this.state.shipToName : null,
          customerId: this.state.currentCustomerId,
          paymentInstrumentId: this.state.giftOrderRequiresPaymentInstrument ? pathOr(null, ['currentPaymentInstrument', 'Id'], this) : null
        }).then(function () {
          _this7.submitRedeemGiftOrderSuccessPopup.open();
        }, function () {
          _this7.submitRedeemGiftOrderErrorPopup.open();
        });
      }
    }
  }, {
    key: "giftPreviewHasProductsOrSubscriptions",
    value: function giftPreviewHasProductsOrSubscriptions() {
      return this.state.giftOrderPreview.products.length !== 0 || this.state.giftOrderPreview.subscriptions.length !== 0;
    }
  }, {
    key: "onAddressSwitcherChangeCallback",
    value: function onAddressSwitcherChangeCallback(newlySelectedAddress) {
      this._updateAddressOnGift(newlySelectedAddress);
    }
  }, {
    key: "onAddressSwitcherCreateOrEditCallback",
    value: function onAddressSwitcherCreateOrEditCallback(newOrUpdatedAddress) {
      var _this8 = this;
      this.actions.retrieveCustomerAddresses(this.state.currentCustomerId).catch(function () {
        if (_this8.state.addressesServiceError) {
          _this8.uiNotificationService.error(_this8.state.addressesServiceError.translatedMessage);
        }
      });
      this._updateAddressOnGift(newOrUpdatedAddress);
    }
  }, {
    key: "onShipToNameChanged",
    value: function onShipToNameChanged() {
      this.actions.updateGiftOrderShipToName(this.selectedShipToName);
    }
  }, {
    key: "_updateAddressOnGift",
    value: function _updateAddressOnGift(updatedAddress) {
      this.actions.updateGiftOrderSelectedShippingAddress(updatedAddress);
      this.selectedShipToName = updatedAddress.ShipToName;
      this.actions.updateGiftOrderShipToName(updatedAddress.ShipToName);
      this._updateShippingMethodOnChange();
    }
  }, {
    key: "_updateShippingMethodOnChange",
    value: function _updateShippingMethodOnChange() {
      var _this9 = this;
      this.actions.getShippingMethodsByCountryCode(this.state.selectedShippingAddress.Country).then(function () {
        _this9.actions.setSelectedShippingMethod(_this9._getShippingMethodOnAddressChange());
        _this9.selectedShippingMethod = _this9.state.selectedShippingMethod;
        _this9.redemptionForm.selectedShippingMethod.$setTouched(); //need to call this because a bad value can be set without ever touching the control
      });
    }
  }, {
    key: "onChangeSelectedShippingMethod",
    value: function onChangeSelectedShippingMethod() {
      if (this.selectedShippingMethod) {
        this.actions.setSelectedShippingMethod(this.selectedShippingMethod);
      }
    }
  }, {
    key: "getShippingMethodDisplayName",
    value: function getShippingMethodDisplayName(shippingMethod) {
      var shippingCost = this.$filter('invCurrency')(shippingMethod.ShippingCost, shippingMethod.Currency);
      return "".concat(shippingCost, " - ").concat(shippingMethod.Name);
    }
  }, {
    key: "_getShippingMethodOnAddressChange",
    value: function _getShippingMethodOnAddressChange() {
      var _this10 = this;
      //find if we can select the currently selected shipping method again
      if (this.state.selectedShippingMethod) {
        var isSelectedShippingMethodAvailable = any(function (shippingMethod) {
          return shippingMethod.Id === pathOr(null, ['Id'], _this10.state.selectedShippingMethod);
        }, this.state.shippingMethods);
        if (isSelectedShippingMethodAvailable) {
          return this.state.selectedShippingMethod;
        }
      }

      // if not lets try for the shipping method that was chosen on the order originally
      var isOrderedShippingMethodAvailable = any(function (shippingMethod) {
        return shippingMethod.Id === pathOr(null, ['shippingMethod', 'Id'], _this10.state.giftOrderPreview);
      }, this.state.shippingMethods);
      if (isOrderedShippingMethodAvailable) {
        return this.state.giftOrderPreview.shippingMethod;
      }

      //All else fails, just default to an empty/error state
      return null;
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.resetRedeemGiftOrder();
      this.disconnectRedux();
    }
  }]);
}();
export default {
  template: require('./redeem.gift.order.html'),
  bindings: {},
  controller: RedeemGiftOrderController
};